import { Document, LocalFile } from '@graphql/generated';
import { mapLocalFilesToDocuments } from '@utils/fileUtils';

type ProcessFilesFn = (
  documents: Document[]
) => Promise<{ blobId: string; clientId: string; numericBlobId: string }[]>;

/**
 * Uploads a team logo LocalFile and returns the blobId to pass as avatarBlobId
 * in TeamAttributes. Returns undefined when the logo is absent or already an
 * uploaded server file (non-LocalFile), so the caller can pass it directly to
 * createTeam/updateTeam without extra branching.
 */
export const uploadTeamLogo = async (
  logo: LocalFile | null | undefined,
  processFiles: ProcessFilesFn
): Promise<string | undefined> => {
  if (logo?.__typename !== 'LocalFile') return undefined;
  const [result] = await processFiles(mapLocalFilesToDocuments([logo]));
  return result?.blobId;
};
